"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimType = exports.ClaimStatus = void 0;
var ClaimStatus;
(function (ClaimStatus) {
    ClaimStatus["NEW"] = "NEW";
    ClaimStatus["REDEEMED"] = "REDEEMED";
    ClaimStatus["EXPIRED"] = "EXPIRED";
})(ClaimStatus || (exports.ClaimStatus = ClaimStatus = {}));
var ClaimType;
(function (ClaimType) {
    ClaimType["TEMPLATE"] = "TEMPLATE";
    ClaimType["TOKEN"] = "TOKEN";
    ClaimType["VESTING"] = "VESTING";
})(ClaimType || (exports.ClaimType = ClaimType = {}));
//# sourceMappingURL=claim.js.map